import styled, { keyframes, css } from 'styled-components'

const colors = {
  letterStartColor: '#fcd74d',
  letterStartColorHover: '#fffc9e',
  letterIncorrect: '#f66257',
  letterCorrect: 'lightgreen',
}

export const Wrapper = styled.div`
  max-width: 960px;
  margin: 0 auto;
  background: #333;
  color: white;
  box-sizing: border-box;
  padding: 25px;
  position: relative;
  min-height: 310px;
  user-select: none;
`
/*
const letterPosition = css`
  ${props =>
    props.top && props.left
      ? `top: ${props.endPos === 0 ? props.top : props.top + 70}px; left: ${
          props.endPos !== 0 ? props.endPos : props.left
        }px;`
      : ``}
`
*/
const moveLetterInAnim = props => keyframes`
        0% {
          top:${props.top}px;
          left:${props.left}px;
        }
        100% {
          top:${props.top + 70}px;
          left:${props.endPos}px;
        }
`

const moveLetter = props => css`
  animation: ${moveLetterInAnim(props)} 0.3s ease-out both;
`

const letterPosition = css`
  ${props =>
    props.endPos === 0
      ? `top:${props.top}px; left:${props.left}px;`
      : moveLetter(props)}
`

export const Letter = styled.button`
  position: absolute;
  border: none;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  color: black;
  font-size: 25px;
  z-index: 10;

  transition: transform 0.15s ease-out, color 0.15s ease-out;
  ${props => letterPosition}

  ${props =>
    !props.locked
      ? `
      background: ${colors.letterStartColor}; 
      cursor: pointer; 
      &:hover {transform: scale(1.2); background:${colors.letterStartColorHover};};
      &:focus {background: ${colors.letterStartColor};}`
      : `
      background: ${
        props.lettersComplete && props.answerCorrect
          ? colors.letterCorrect
          : props.lettersComplete
          ? colors.letterIncorrect
          : colors.letterStartColorHover
      }; &:focus {background: ${
          props.lettersComplete && props.answerCorrect
            ? colors.letterCorrect
            : props.lettersComplete
            ? colors.letterIncorrect
            : colors.letterStartColorHover
        };}`}
`

const letterMarkerCurrent = css`
  background: white;
  transform: scale(1.15);
`

export const LetterMarker = styled.div`
  position: absolute;
  border-radius: 5px;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  background: ${props =>
    props.highlighted
      ? `rgba(255, 255, 255, 0.7)`
      : `rgba(255, 255, 255, 0.15)`};
  z-index: 9;
  ${props =>
    props.top && props.left
      ? `top: ${props.top}px; left: ${props.left}px;`
      : ``}
`

export const ResetButton = styled.button`
  position: absolute;
  bottom: 25px;
  margin-left: 55px;
  color: white;
  text-align: left;
  font-size: 22px;
  border: none;
  background: #ff8080;
  color: black;
  padding: 8px 15px;
  font-size: 22px;
  display: block;
  border-radius: 5px;
  border-bottom: 4px solid #be2f2f;
  cursor: pointer;
  &:focus {
    background: #ff8080;
  }
`

export const Question = styled.div`
  font-size: 25px;
  text-align: left;
  margin-left: 50px;
  border-bottom: 1px solid #aaa;
  padding-bottom: 5px;
  box-sizing: border-box;
`

export const Correct = styled.div`
  position: absolute;
  bottom: 25px;
  margin-left: 50px;
  color: white;
  text-align: left;
  font-size: 22px;
`

export const NextQuestion = styled.a`
  padding-left: 20px;
  text-decoration: underline;
  cursor: pointer;
`
